<template>
    <form
        @submit.prevent="subscribe"
        :action="url"
        method="post"
        class="p-4 space-y-4"
    >
        <div class="text-center text-xl font-semibold text-gray-700">Subscribe to get a weekly email of the latest SQL jobs.</div>
        <div class="form-control">
            <div class="flex">
                <input
                    type="text"
                    v-model="form.email"
                    placeholder="Email"
                    class="form-input rounded-r-none flex-1"
                    :class="{ error: form.errors.email }"
                >
                <loading-button
                    :loading="form.processing"
                    class="btn btn-green rounded-l-none"
                    type="submit"
                >
                    Subscribe
                </loading-button>
            </div>
            <small v-if="form.errors.email" class="form-error">{{ form.errors.email }}</small>
        </div>
    </form>
</template>

<script setup>
import useForm from '@/functions/useForm'

import { useNotificationStore } from '@/stores/notification'
import { trackEvent } from '../functions/googleAnalytics';

const notification = useNotificationStore()

const props = defineProps({
    url: {
        type: String,
        required: true,
    }
})

const form = useForm({
    email: ''
})

const subscribe = () => form.post(props.url, {
    onSuccess: () => {
        form.reset()
        notification.set({
            'type': 'modal',
            'heading': 'Subscribed',
            'body': "You'll now receive a weekly email of the latest SQL Jobs."
        })
        trackEvent('subscribe')
    }
})
</script>
